import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};

export const ceilingTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  size: "mini",
  selection: true,
  menu: true,
  menuBtnTitle: "更多",
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "400",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "代理商",
      prop: "rootDepartId",
      type: "select",
      search: true,
      hide: true,
    },
    /* {
      label: "工程师电话",
      prop: "engineerMobile",
      type: "input",
      search: true,
      rules: [
        { required: true, trigger: "blur", validator: validateNumber }
      ],
    }, */
    {
      width: 100,
      label: "订单状态",
      prop: "orderStatus",
      type: "select",
      dicData: DIC.ORDER_CEILING_STATUS,
      search: true,
      solt: true,
    },
    // appointmentType
    /* {
      label: "渠道",
      prop: "appointmentType",
      type: "input", 
    }, */
    {
      width: 100,
      label: "销售部门",
      prop: "region",
      type: "input",
      search: true,
      overHidden: true,
    },
    {
      label: "施工地址(区/县)",
      prop: "customAddress",
      type: "input",
      search: true,
      overHidden: true,
      rules: [
        { required: true, trigger: "blur", validator: validateName }
      ],
    },
    {
      label: "报单商家名称",
      prop: "shopName",
      type: "input",
      search: true,
      rules: [
        { required: true, trigger: "blur", validator: validateName }
      ],
    },
    {
      label: "报单商家电话",
      prop: "shopMobile",
      type: "input",
      search: true,
      rules: [
        { required: true, trigger: "blur", validator: validateNumber }
      ],
    },
    {
      label: "户型",
      prop: "houseType",
      type: "input",
      overHidden: true,
      rules: [
        { required: true, trigger: "blur", validator: validateName }
      ],
    },
    {
      label: "付款人姓名",
      prop: "customName",
      span: 12,
      search: true,
      type: "input",
      rules: [
        { required: true, trigger: "blur", validator: validateName }
      ],
    },
    {
      label: "付款人电话",
      prop: "customMobile",
      span: 12,
      search: true,
      type: "input",
      rules: [
        { required: true, trigger: "blur", validator: validateNumber }
      ],
    },
    // {
    //   label: "房屋类型",
    //   prop: "installationType",
    //   type: "input",
    //   overHidden: true,
    // },
    // {
    //   label: "安装形式",
    //   prop: "installationForm",
    //   type: "input",
    //   overHidden: true,
    // },
    /* {
      label: "拆除原吊顶",
      prop: "remove",
      type: "input",
    }, */
    /* {
      label: "正投影面积",
      prop: "area",
      type: "input",
      overHidden: true,
      rules: [
        { required: true, trigger: "blur", validator: validateNumber }
      ],
    }, */
    /* {
      label: "付款形式",
      prop: "payType",
      type: "input",
      overHidden: true,
    }, */
    /* {
      label: "上门测量时间",
      prop: "measureTime",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
    }, */
    {
      label: "预计进场时间",
      prop: "entranceTime",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd",
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "开始时间",
      prop: "timeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "timeEnd",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "业务员",
      prop: "salesperson",
      type: "input",
      overHidden: true,
      rules: [
        { required: true, trigger: "blur", validator: validateName }
      ],
    },
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      span: 24,
      overHidden: true,
      max: 255,
    },
  ],
};
